/* eslint-disable */
import React, { useEffect, useState, useRef } from "react";
import * as API from '../../framework/API/api';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { COLUMNSTYPE, ENTITYNAME, IMPORT_STATUS, INGESTIONTEMPLATETYPES, INGESTION_MODULETYPES, PARTNER_INGESTION_STATUS, TOAST_TYPES } from "../../framework/constant/constant";
import PartnerIntegrationDetailCollection from "./SubComponents/PartnerIntegrationDetailCollection";
import { utility } from "../../framework/utility/utilityProvider";
import { useTranslation } from "../../locale/useTranslation";
import moment from "moment";
import { ConfirmAlert } from "../../ConfirmAlert";
import RoundButton from "../../framework/forms/helpercomponents/buttons/RoundButton";
import { ProgressBar } from "@progress/kendo-react-progressbars";
import HeaderRowAndSheetPopup from "./SubComponents/HeaderRowAndSheetPopup";
import MyMultiSelect from "../../components/MyMultiSelect";
import ToastNotification from "../../components/ToastNotification";

const PartnerIngetion = () => {

  const lang = useTranslation();
  const CHUCKEDSIZE = 50;

  const [showProgressBar, setShowProgressBar] = useState({
    okButton: false,
    progressBarPopup: false,
  });
  const [progressData, setProgressData] = React.useState({
    message: '',
    progress: 0,
  });

  const [showHeaderRowSheetIndexPopup, setShowHeaderRowSheetIndexPopup] = useState(false);
  const [selectedExcelSheets, setSelectedExcelSheets] = useState([]);
  const [headerRowSheetIndex, setHeaderRowSheetIndex] = useState({
    HeaderRowIndex: 1,
    SheetIndex: 0
  });
  const [isLoading, setIsLoading] = useState(false);

  let mediaEpisodeMetaData = {
    PGRating: {},
    CensorRating: {},
    MediaTechnicalPrototype: {},
    Languages: [],
    Keywords: "",
    ProductionYear: "",
    Synopsis: [],
    CastAndCrew: [],
    MediaEpisodeSID: 0,
    MediaEpisode_id: ""
  };

  const [dataItem, setDataItem] = useState({
    Url: "",
    SearchText: "",
    RequestType: { SID: 1, Description: "GET" },
    SearchTextValue: "",
    Response: "",
    Body: "",
    Status: { SID: 0, Description: "All" },
    Template: {}
  });

  //REPLACE PLANNING STATE
  const [replacePlanning, setReplacePlanning] = useState(false);
  const [createMedia, setCreateMedia] = useState(false);
  const [createParent, setCreateParent] = useState(false);
  const [updateSegmentation, setUpdateSegmentation] = useState(false);
  const [updateMedia, setUpdateMedia] = useState(false);
  const [fillGap, setFillGap] = useState(false);
  const [scheduleDate, setScheduleDate] = useState("");

  const [channels, setChannels] = useState([]);
  const [platforms, setPlatforms] = useState([]);
  const [matchType, setMatchType] = useState({});
  const [selectedIngestionTemplateFileType, setSelectedIngestionTemplateFileType] = useState("");
  const [clearSelected, setClearSelected] = useState(false);

  // FILE SECTION VARIABLES
  const [isAPITemplateSelected, setIsAPITemplateSelected] = useState(false);
  const [fileDataItem, setFileDataItem] = useState(!isAPITemplateSelected ? { file: "" } : {});
  const [files, setFiles] = useState([]);// to store selected file
  const fileRef = useRef(null); // to make ref null so that you can import same file again and again

  const [filterIngestionData, setFilterIngestionData] = useState([]);
  const [ingetionData, setIngetionDataState] = useState([]);
  const ingestionDataRef = useRef([]);
  const setIngetionData = (data) => {
    ingestionDataRef.current = data;
    setIngetionDataState(data);
  }

  const partnerIngestionRef = useRef();

  const [selectedIngestionDataToSave, setSelectedIngestionDataToSave] = useState([]);
  const [selectAllChannels, setSelectAllChannels] = useState(false);

  const setSelectedIngestionData = (dataList) => {
    // REMOVING INDEX PROPERTY 
    //dataList.forEach(function(ex){ delete ex.Index });
    setSelectedIngestionDataToSave(dataList);
  }

  //const [requestType, setrequestType] = useState([{SID:1,Description:"GET"},{SID:2,Description:"POST"},{SID:3,Description:"PUT"},{SID:4,Description:"DELETE"}]);
  const [status, setStatus] = useState([]);
  const [filterSearch, setFilterSearch] = useState("");
  // const [selectedResponseTab, setselectedResponseTab] = useState(0);

  const [partnerIngetionTemplates, setPartnerIngetionTemplates] = useState([]);
  const genres = useRef([]);
  const pgRatings = useRef([]);
  const languages = useRef([]);
  const platformTypes = useRef([]);
  const mediaCategoryTypes = useRef([]);
  const brands = useRef([]);
  const products = useRef([]);
  const channelsRef = useRef([]);
  const platformRef = useRef([]);
  const matchTypeRef = useRef([]);

  useEffect(() => {
    loadCombo();
  }, [])

  const loadCombo = async () => {
    let partnerIngetionTemplates = await API.getDataLookup(ENTITYNAME.PartnerIntegrationTemplate);
    setPartnerIngetionTemplates(partnerIngetionTemplates.data);
    genres.current = await API.getDataLookupData(ENTITYNAME.Genre);
    pgRatings.current = await API.getDataLookupData(ENTITYNAME.PGRating);
    languages.current = await API.getDataLookupData(ENTITYNAME.Language);
    platformTypes.current = await API.getDataLookupData(ENTITYNAME.PlatformType);
    mediaCategoryTypes.current = await API.getDataLookupData(ENTITYNAME.MediaCategoryType);
    brands.current = await API.getDataLookupData(ENTITYNAME.Brand);
    products.current = await API.getDataLookupData(ENTITYNAME.Product);
    channelsRef.current = await API.getDataLookupData(ENTITYNAME.Channel);
    platformRef.current = await API.getDataLookupData(ENTITYNAME.Platform);
    matchTypeRef.current = await API.getDataLookupData(ENTITYNAME.MatchType);
    let statusRes = Object.keys(PARTNER_INGESTION_STATUS).map((key) => { return { SID: PARTNER_INGESTION_STATUS[key], Description: key } });
    statusRes.unshift({ SID: 0, Description: "All" });
    setStatus(statusRes);
  }

  const handleChange = (e) => {

    setDataItem({ ...dataItem, [e.target.name]: e.target.value });
    setIsAPITemplateSelected(e.target.value.IngestionTemplateType.Description.toLowerCase() === "api");

    //SETTING DATA AND FILE TO DEFAULT VALUE
    setIngetionData([]);
    setFilterIngestionData([]);

    //SETTING MESSGE FOR USER
    setSelectedIngestionTemplateFileType(e.target.value.IngestionTemplateType.Description);

    if (e.target.value.isOtt) {
      setPlatforms(platformRef.current);
    }

  };

  const handleBrowseClick = () => {
    fileRef.current.click();
  }

  // const handleFileChange = async (e) => {
  //   setFileDataItem({ ...fileDataItem, [e.target.name]: e.target.value });
  //   setFiles(e.target.files[0]);
  //   setIngetionData([]);
  //   setFilterIngestionData([]);

  //   //ON SELECT FILE SET DATA IN GRID
  //   if (dataItem.Template?.IngestionTemplateType?.SID == INGESTIONTEMPLATETYPES.Excel) {
  //     let excelSheetsRes = await API.getExcelSheets(e.target.files[0]);
  //     if (excelSheetsRes.success && excelSheetsRes.data.length > 0) {
  //       setSelectedExcelSheets(excelSheetsRes.data);
  //     }
  //     setHeaderRowSheetIndex({ HeaderRowIndex: 1, SheetIndex: 0 });
  //     setShowHeaderRowSheetIndexPopup(true);
  //   } else {
  //     await loadDataOnFileSelect({ ...fileDataItem, [e.target.name]: e.target.value }, e.target.files[0])
  //   }

  // };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    const fileName = file ? file.name : "";
    setFileDataItem({ ...fileDataItem, [e.target.name]: fileName });
    setFiles(file);

    //ON SELECT FILE SET DATA IN GRID
    if (dataItem.Template?.IngestionTemplateType?.SID == INGESTIONTEMPLATETYPES.Excel) {
      setIngetionData([]);
      setFilterIngestionData([]);
      let excelSheetsRes = await API.getExcelSheets(file);
      if (excelSheetsRes.success && excelSheetsRes.data.length > 0) {
        setSelectedExcelSheets(excelSheetsRes.data);
      }
      setHeaderRowSheetIndex({ HeaderRowIndex: 1, SheetIndex: 0 });
      setShowHeaderRowSheetIndexPopup(true);
    } else {
      await loadDataOnFileSelect({ ...fileDataItem, [e.target.name]: fileName }, file)
    }
  };

  const handleOnHeaderRowSheetIndexConfirm = async () => {
    await loadDataOnFileSelect(fileDataItem, files);
  }

  const onLoadDataViaAPI = async (e) => {

    if (!dataItem.Template || Object.keys(dataItem.Template)?.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.please_select_template_error_message}` });
      return
    }

    // empty list
    setIngetionData([]);
    setFilterIngestionData([]);
    setSelectedIngestionData([]);

    let items = [];

    let data = await getDataFromAPI();
    items.push(...data);

    if (dataItem.Template?.ModuleType?.SID == INGESTION_MODULETYPES.PlanningGrid) {
      setPlannerGridData(items)
    } else {
      setIngetionData(items);
      setFilterIngestionData(items);
    }

  }

  const loadDataOnFileSelect = async (fileDataItem, files) => {

    if (!dataItem.Template || Object.keys(dataItem.Template)?.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_template_error_message });
      return;
    }

    if (!isAPITemplateSelected && !fileDataItem.file) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_file_first_error_message });
      return;
    }

    setShowHeaderRowSheetIndexPopup(false);
    setIsLoading(true);

    // empty list
    setIngetionData([]);
    setFilterIngestionData([]);
    setSelectedIngestionData([]);

    let items = [];
    let fileData = await getDataFromFile(files);

    if (fileData.success) {
      items = [...fileData.data];
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: fileData.message });
      setIsLoading(false);
      return;
    }

    if (dataItem.Template?.ModuleType?.SID == INGESTION_MODULETYPES.PlanningGrid) {
      setPlannerGridData(items);
    } else {
      let index = ingetionData.length + 1;

      for (let i = 0; i < items.length; i++) {
        await getCastedItemAsPerTemplateMapping(items[i], index);
        index++;
      }
    }
    
    setIsLoading(false);
  };

  const getDataFromAPI = async () => {

    let payload = {
      data: dataItem.Template,
    }

    let mappedRes = await API.getMappedDataFromAPI(payload);

    if (mappedRes.success) {
      return mappedRes.data
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: mappedRes.message });
      return [];
    }
  }

  const getDataFromFile = async (files) => {
    let res = {};

    if (dataItem.Template?.ModuleType?.SID == INGESTION_MODULETYPES.PlanningGrid) {
      res = await API.readPlannerGridCSV(files);
    } else {
      res = await API.readFile(
        files,
        headerRowSheetIndex.HeaderRowIndex - 1,
        headerRowSheetIndex.SheetIndex
      );
    }

    fileRef.current.value = null;

    let mappingKeys =
      dataItem.Template?.Mapping &&
      dataItem.Template?.Mapping?.length > 0 &&
      dataItem.Template?.Mapping?.map((x) => x.PartnerKey);

    if (res.success && res.data && res.data?.data.length > 0) {
      let data = [];

      if (
        dataItem.Template?.IngestionTemplateType?.SID ==
        INGESTIONTEMPLATETYPES.Excel
      ) {
        if (!utility.checkValidImportFile(res.data.columns, mappingKeys)) {
          return {
            success: false,
            data: [],
            message: lang.invalid_file_error_message,
          };
        }

        res.data.data.forEach((x) => {
          let obj = {};
          res.data.columns.forEach((col, i) => {
            obj = { ...obj, [col]: x[i] };
          });
          data.push(obj);
        });
      } else {
        if (
          dataItem.Template?.ModuleType?.SID ==
          INGESTION_MODULETYPES.PlanningGrid
        ) {
          data = res.data.data;
        } else {
          let columns = Object.keys(res.data.data[0]);

          if (!utility.checkValidImportFile(columns, mappingKeys)) {
            return {
              success: false,
              data: [],
              message: lang.invalid_file_error_message,
            };
          }

          data = res.data.data;
        }
      }

      return {
        success: true,
        data,
        message: "File Data",
      };
    }

    return {
      success: false,
      data: [],
      message:
        res.data?.data?.length === 0
          ? "No data found"
          : "Error While Reading File !!",
    };
  };

  const setPlannerGridData = (items) => {

    let data = [];
    let index = 1;
    for (let i = 0; i < items.length; i++) {
      const line = items[i];
      const keys = Object.keys(line);
      const slotTime = line[keys[0]];

      for (let j = 1; j < keys.length; j++) {
        const date = keys[j];
        const assetId = line[date];

        if (date != undefined) {

          let [d, m, y] = date.includes('-') ? date.split('-') : date.split('/');
          let fullYear = new Date(`${m}/${d}/${y}`).getFullYear()

          if (assetId && assetId.length > 0) {
            data.push({
              Index: index,
              AssetId: assetId,
              Date: utility.convertExcelDateAndTimeInMilliseconds(`${fullYear}-${m}-${d}`, COLUMNSTYPE.date),
              Time: utility.convertStringTimeToMilliseconds(slotTime),
              SlotDateTime: utility.convertExcelDateAndTimeInMilliseconds(`${fullYear}-${m}-${d}`, COLUMNSTYPE.date) + utility.convertStringTimeToMilliseconds(slotTime)
            });
            index = index + 1
          }
        }
      }

    }

    data.sort((a, b) => parseInt(a.SlotDateTime) - parseInt(b.SlotDateTime));

    setIngetionData(data);
    setFilterIngestionData(data);

  }

  const setUpdatedDataInIngestionDetails = (responseData) => {

    let newData = [...ingestionDataRef.current];
    if (responseData && responseData.length > 0) {
      responseData.forEach((obj) => {
        let index = ingestionDataRef.current.findIndex((x) => x.Index == obj.Index);
        newData.splice(index, 1, obj)
      });
    }

    setIngetionData(newData);
    setFilterIngestionData(newData);

  }

  const onIngest = () => {
    if (selectedIngestionDataToSave.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_atleast_one_item });
      return;
    }

    if ((dataItem.Template?.ModuleType?.SID == INGESTION_MODULETYPES.Schedule || dataItem.Template?.ModuleType?.SID == INGESTION_MODULETYPES.Planning) && selectedIngestionDataToSave.length != ingetionData.length) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_all_data_while_importing_playlist });
      return;
    }

    if (dataItem.Template?.ModuleType?.SID == INGESTION_MODULETYPES.Schedule && dataItem.Template?.isSelectManualDate && scheduleDate.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_schedule_date_error_message });
      return;
    }

    if (
      !(dataItem.Template?.ModuleType?.IsContentRequired &&
        (channels.length != 0 || platforms.length != 0)) &&
      dataItem.Template?.ModuleType?.SID != INGESTION_MODULETYPES.Segmentation &&
      dataItem.Template?.ModuleType?.SID != INGESTION_MODULETYPES.Planning &&
      dataItem.Template?.ModuleType?.SID != INGESTION_MODULETYPES.PlanningGrid &&
      dataItem.Template?.ModuleType?.SID != INGESTION_MODULETYPES.Schedule &&
      dataItem.Template?.ModuleType?.SID != INGESTION_MODULETYPES.Agency &&
      dataItem.Template?.ModuleType?.SID != INGESTION_MODULETYPES.Client &&
      dataItem.Template?.ModuleType?.SID != INGESTION_MODULETYPES.OPTA &&
      dataItem.Template?.ModuleType?.SID != INGESTION_MODULETYPES.MAMAsset &&
      dataItem.Template?.ModuleType?.SID != INGESTION_MODULETYPES.Synopsis &&
      dataItem.Template?.ModuleType?.SID != INGESTION_MODULETYPES.CastAndCrew
    ) {

      ConfirmAlert(
        () => saveChuckedData(),
        () => { },
        lang.Confirmation_label,
        lang.partner_ingestion_media_deal_right_confirmation_message
      );

    } else {
      saveChuckedData();
    }

  }

  const saveChuckedData = async () => {

    let onSaveResposnse = false;

    let finalDataToSave = [...selectedIngestionDataToSave];

    if (dataItem.Template?.ModuleType?.SID == INGESTION_MODULETYPES.Schedule && dataItem.Template?.isSelectManualDate) {
      finalDataToSave = finalDataToSave.map((x) => {
        return { ...x, Date: utility.convertStringDatetoMilliseconds(scheduleDate) }
      })
    }

    let finalChuckedSize = dataItem.Template?.ModuleType?.isChunked ? CHUCKEDSIZE : finalDataToSave.length;

    setShowProgressBar({ okButton: false, progressBarPopup: true });


    let dataRowIndex = 0;
    while (dataRowIndex < finalDataToSave.length) {
      setProgressData({ message: 'Data uploading...', progress: Math.round(((dataRowIndex + 1) / finalDataToSave.length) * 100) });

      let chunckedData = [...finalDataToSave.slice(dataRowIndex, dataRowIndex + finalChuckedSize)]; //add first row again in data
      onSaveResposnse = await onSave(chunckedData);

      if (!onSaveResposnse) break;

      dataRowIndex = dataRowIndex + finalChuckedSize;
    }

    if (onSaveResposnse) {
      setProgressData({ message: 'Process completed', progress: 100 });
      setShowProgressBar({ okButton: true, progressBarPopup: true });
      ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: 'Process completed' });
      setSelectedIngestionData([]);
      setClearSelected(true);
    }

  }

  const onSave = async (chunckedData) => {

    let lastResponse = {};

    console.log(dataItem.Template);

    let moduleType = dataItem.Template?.ModuleType?.SID;

    switch (moduleType) {
      case INGESTION_MODULETYPES.Planning:

        let planningRes = await importPlanning(createMedia, chunckedData);
        lastResponse = planningRes

        break;

      case INGESTION_MODULETYPES.Program:

        let programRes = await importMediaManagement(chunckedData);
        lastResponse = programRes

        break;


      case INGESTION_MODULETYPES.Movie:

        let movieRes = await importMediaManagement(chunckedData);
        lastResponse = movieRes

        break;

      case INGESTION_MODULETYPES.Commercial:

        let commercialRes = await importMediaManagement(chunckedData);
        lastResponse = commercialRes

        break;


      case INGESTION_MODULETYPES.Filler:

        let fillerres = await importMediaManagement(chunckedData);
        lastResponse = fillerres

        break;

      case INGESTION_MODULETYPES.Interstitial:

        let interstitialRes = await importMediaManagement(chunckedData);
        lastResponse = interstitialRes

        break;

      case INGESTION_MODULETYPES.Series:

        let seriesRes = await importMediaManagement(chunckedData);
        lastResponse = seriesRes

        break;

      case INGESTION_MODULETYPES.Season:

        let seasonRes = await importMediaManagement(chunckedData);
        lastResponse = seasonRes

        break;

      case INGESTION_MODULETYPES.Episode:

        let episodeRes = await importMediaManagement(chunckedData);
        lastResponse = episodeRes

        break;

      case INGESTION_MODULETYPES.OttAsset:

        let ottAssetRes = await importOttAsset();
        lastResponse = ottAssetRes

        break;

      case INGESTION_MODULETYPES.Segmentation:

        let segmentationRes = await importMediaManagement(chunckedData);
        lastResponse = segmentationRes

        break;

      case INGESTION_MODULETYPES.PlanningGrid:

        let planningGridRes = await importPlanning(false, chunckedData);
        lastResponse = planningGridRes

        break;

      case INGESTION_MODULETYPES.Schedule:

        let playlistGridRes = await importPlaylist(chunckedData);
        lastResponse = playlistGridRes

        break;

      case INGESTION_MODULETYPES.Agency:

        let agencyRes = await importAgencyClient(chunckedData);
        lastResponse = agencyRes

        break;

      case INGESTION_MODULETYPES.Client:

        let clientRes = await importAgencyClient(chunckedData);
        lastResponse = clientRes

        break;

      case INGESTION_MODULETYPES.OPTA:

        let optaRes = await importOPTADetails(chunckedData);
        lastResponse = optaRes

        break;

      case INGESTION_MODULETYPES.MAMAsset:

        let mamAssestRes = await importMAMAssets(chunckedData);
        lastResponse = mamAssestRes

        break;

      case INGESTION_MODULETYPES.Synopsis:

        let synopsisRes = await importSynopsis(chunckedData);
        lastResponse = synopsisRes

        break;

      case INGESTION_MODULETYPES.CastAndCrew:

        let castAndCrewRes = await importCastAndCrew(chunckedData);
        lastResponse = castAndCrewRes

        break;

      default:

        // for (const item of selectedIngestionDataToSave) {
        //   lastResponse = await saveSingleMedia(item);
        //   responses.push(lastResponse);
        //   console.log(lastResponse);
        // }


        break;
    }

    console.log(selectedIngestionDataToSave.length);
    if (lastResponse.success) {

      // console.log("coming here");
      // const success = responses.filter(x => x.success).length;
      // const failed = responses.filter(x => !x.success).length;

      console.log(lastResponse)




      return true;

    } else {

      console.log("here in last");
      setShowProgressBar({ okButton: false, progressBarPopup: false });
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lastResponse.message });
      return false;
    }

  }

  const importPlanning = async (createMedia = true, chunckedData) => {
    var planningItems = []; //FOR VALID ROW
    var rowData = [];

    let columns = Object.keys(chunckedData[0]);


    if (dataItem.Template?.Channel == undefined) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.please_select_channel_error_message}` });
      return;
    }


    //CHECK IF THE READ DATA HAS TIME,DATE and HOUSENUMBER COLUMNS
    if (!columns.includes("Date") || !columns.includes("Time") || !columns.includes("AssetId")) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.date_time_houseNumber_column_is_mandatory}` });
      return;
    }

    // ADDING ONLY VALID ROWS
    chunckedData.forEach((item) => {
      //check valid date format
      if (item.Date.length == 0 && !moment(item.Date, "YYYY-MM-DD", true).isValid()) {
        rowData.push({ ...item, success: PARTNER_INGESTION_STATUS.Failed, message: 'missing/wrong date format', importStatus: IMPORT_STATUS.MissingValue });

        //checking valid time format
      } else if (item.Time.length == 0) {
        rowData.push({ ...item, success: PARTNER_INGESTION_STATUS.Failed, message: 'missing/wrong time format', importStatus: IMPORT_STATUS.MissingValue });

        //checking if assetId missing
      } else if (item.AssetId.length == 0) {
        rowData.push({ ...item, success: PARTNER_INGESTION_STATUS.Failed, message: 'missing House Number', importStatus: IMPORT_STATUS.MissingValue });

      } else {
        rowData.push({ ...item, success: PARTNER_INGESTION_STATUS.Pending, message: 'Importing please wait', importStatus: IMPORT_STATUS.Pending });

        let planning = {
          ...item,
          Channel: dataItem.Template?.Channel,
          ScheduleDate: item.Date + item.Time,
          SlotDateTime: item.Date + item.Time,
          AssetId: item.AssetId,
          Title: item.Title,
          EpisodeTitle: item.EpisodeTitle,
          Duration: item.Duration
        };

        planningItems.push(planning);
      }
    });

    //boolean to replicate data 
    let planningResponse = await API.importPlanning(planningItems, replacePlanning, createMedia);
    // socket()?.emit(SOCKET_EVENTS.onSocketData, { action: SOCKET_ACTION.PLANNING_REFRESH, module: MODULE.PLANNING, data: null });
    if (planningResponse.success) {
      return { ...planningResponse, success: planningResponse.success, data: setUpdatedDataInIngestionDetails([...rowData, ...planningResponse.data]), message: planningResponse.message };
    } else {
      return planningResponse;
    }
  };

  const importOttAsset = async () => {

    let payload = {
      data: ingestionDataRef.current,
      provider: dataItem.Template?.Provider,
      moduleType: dataItem.Template?.ModuleType,
    };

    let res = await API.importOttAsset(payload);

    console.log(res);

    if (res.success) {
      return { success: res.success, data: setUpdatedDataInIngestionDetails(res.data), message: res.message };
    } else {
      return res;
    }

  }

  const importMediaManagement = async (chunckedData) => {

    let payload = {
      data: chunckedData,
      MediaImportType: dataItem.Template?.ModuleType,
      GenerateAssetId: false, // NEED TO ASK
      Content: dataItem.Template?.Content,
      UpdateMedia: updateMedia,
      provider: dataItem.Template?.Provider ?? {},
      moduleType: dataItem.Template?.ModuleType,
      channels: channels,
      platforms: platforms,
      createParent: createParent ?? false,
      updateSegmentation: updateSegmentation ?? false,
      matchType: matchType ?? {},
      isSports: dataItem.Template?.IsSports ?? false
    };

    let res = await API.ImportMediaManagementDataMigration(
      payload,
      dataItem.Template?.ModuleType
    );

    if (res.success) {
      return { ...res, success: res.success, data: setUpdatedDataInIngestionDetails(res.data), message: res.message };
    } else {
      return res;
    }

  }

  const importPlaylist = async (chunckedData) => {

    let payload = {
      data: chunckedData,
      channel: dataItem.Template?.Channel,
      canReplace: replacePlanning,
      createMedia: createMedia,
      fillGaps: fillGap
    }

    console.log(payload);
    let res = await API.importPlaylistIngestion(payload);
    console.log(res);

    if (res.success) {
      return { ...res, success: res.success, data: setUpdatedDataInIngestionDetails(res.data), message: res.message };
    } else {
      return res;
    }

  }

  const importAgencyClient = async (chunckedData) => {

    let payload = {
      data: chunckedData,
      canUpdate: false //replacePlanning,
    }

    console.log(payload);
    let res = await API.importAgencyClient(payload, dataItem.Template?.ModuleType);
    console.log(res);

    if (res.success) {
      return { ...res, success: res.success, data: setUpdatedDataInIngestionDetails(res.data), message: res.message };
    } else {
      return res;
    }

  }

  const importOPTADetails = async (chunckedData) => {

    let payload = {
      data: chunckedData,
      channel: dataItem.Template?.Channel
    }

    console.log(payload);
    let res = await API.importOPTADetails(payload);
    console.log(res);

    if (res.success) {
      return { ...res, success: res.success, data: setUpdatedDataInIngestionDetails(res.data), message: res.message };
    } else {
      return res;
    }

  }

  const importMAMAssets = async (chunckedData) => {

    let payload = {
      data: chunckedData,
      // channel : dataItem.Template.Channel
    }

    console.log(payload);
    let res = await API.importMAMAssets(payload);
    console.log(res);

    if (res.success) {
      return { ...res, success: res.success, data: setUpdatedDataInIngestionDetails(res.data), message: res.message };
    } else {
      return res;
    }

  }


  const importSynopsis = async (chunckedData) => {

    let payload = {
      data: chunckedData,
      isUpdateData: updateMedia
    }

    console.log(payload);
    let res = await API.importSynopsis(payload);
    console.log(res);

    if (res.success) {
      return { ...res, success: res.success, data: setUpdatedDataInIngestionDetails(res.data), message: res.message };
    } else {
      return res;
    }

  }

  const importCastAndCrew = async (chunckedData) => {

    let payload = {
      data: chunckedData,
      isUpdateData: updateMedia
    }

    console.log(payload);
    let res = await API.importCastAndCrew(payload);
    console.log(res);

    if (res.success) {
      return { ...res, success: res.success, data: setUpdatedDataInIngestionDetails(res.data), message: res.message };
    } else {
      return res;
    }

  }

  const getCastedItemAsPerTemplateMapping = async function (res, ind) {

    let tempData = []

    let mediaEpisode = {
      Content: dataItem.Template?.Content,
      MediaCategory: dataItem.Template?.ModuleType?.MediaCategory,
      MediaCategoryType: null,
      Archive: false,
      SaveEntityName: dataItem.Template?.ModuleType?.SaveEntityName,
      Publishings: [],
      Source_id: res["_id"],
      success: PARTNER_INGESTION_STATUS.Pending,
    };


    let mappingKeys = dataItem.Template?.Mapping;

    for (var i = 0; i < mappingKeys.length; i++) {

      let keyName = mappingKeys[i].Key;
      switch (keyName) {

        case "AssetId":
          if (isAPITemplateSelected || !res[mappingKeys[i].PartnerKey]) mediaEpisode.AssetId = "AUTO GENERATED";
          else mediaEpisode.AssetId = res[mappingKeys[i].PartnerKey];

          break;

        // case "MediaCategoryType":
        //   mediaEpisode.MediaCategoryType = await getMediaCategoryType(res[mappingKeys[i].PartnerKey]);
        //   break;

        case "Time":

          console.log('Time -', res[mappingKeys[i].PartnerKey])
          if (isAPITemplateSelected || !res[mappingKeys[i].PartnerKey]) mediaEpisode.Time = "AUTO GENERATED";
          else mediaEpisode.Time = utility.convertExcelDateAndTimeInMilliseconds(res[mappingKeys[i].PartnerKey], COLUMNSTYPE.time, mappingKeys[i].Format)

          break;

        case "Duration":
          if (res[mappingKeys[i].PartnerKey] == undefined) mediaEpisode.Duration = 0;
          else mediaEpisode.Duration = utility.convertExcelDateAndTimeInMilliseconds(res[mappingKeys[i].PartnerKey], COLUMNSTYPE.time, mappingKeys[i].Format)

          break;

        case "ActualDuration":
          if (res[mappingKeys[i].PartnerKey] == undefined) mediaEpisode.ActualDuration = 0;
          else mediaEpisode.ActualDuration = utility.convertExcelDateAndTimeInMilliseconds(res[mappingKeys[i].PartnerKey], COLUMNSTYPE.time, mappingKeys[i].Format)

          break;

        case "TcIn":
          if (res[mappingKeys[i].PartnerKey] == undefined) mediaEpisode.TcIn = 0;
          else mediaEpisode.TcIn = utility.convertExcelDateAndTimeInMilliseconds(res[mappingKeys[i].PartnerKey], COLUMNSTYPE.time, mappingKeys[i].Format)

          break;

        case "TcOut":
          if (res[mappingKeys[i].PartnerKey] == undefined) mediaEpisode.TcOut = 0;
          else mediaEpisode.TcOut = utility.convertExcelDateAndTimeInMilliseconds(res[mappingKeys[i].PartnerKey], COLUMNSTYPE.time, mappingKeys[i].Format)

          break;

        case "Date":

          console.log('Date -', res[mappingKeys[i].PartnerKey])
          if (res[mappingKeys[i].PartnerKey] == undefined) mediaEpisode.Date = 0;
          else mediaEpisode.Date = utility.convertExcelDateAndTimeInMilliseconds(res[mappingKeys[i].PartnerKey], COLUMNSTYPE.date, mappingKeys[i].Format)

          break;

        case "StartDate":
          if (res[mappingKeys[i].PartnerKey] == undefined) mediaEpisode.StartDate = 0;
          else mediaEpisode.StartDate = utility.convertExcelDateAndTimeInMilliseconds(res[mappingKeys[i].PartnerKey], COLUMNSTYPE.date, mappingKeys[i].Format)

          break;

        case "EndDate":
          if (res[mappingKeys[i].PartnerKey] == undefined) mediaEpisode.EndDate = 0;
          else mediaEpisode.EndDate = utility.convertExcelDateAndTimeInMilliseconds(res[mappingKeys[i].PartnerKey], COLUMNSTYPE.date, mappingKeys[i].Format)

          break;

        default:
          mediaEpisode[keyName] = res[mappingKeys[i].PartnerKey];
      }
    }


    // Adding metadata details
    mediaEpisode.MediaEpisodeMetaData = mediaEpisodeMetaData;

    //ADDING RESPONSE TO SHOW ON RESPONSE BUTTON CLICK TO SHOW LATER WE'LL REMOVE IT BEFORE SAVE
    mediaEpisode.SearchResponse = JSON.stringify(res);


    mediaEpisode.Index = isAPITemplateSelected ? ingestionDataRef.current.length + 1 : ind


    tempData = [...ingestionDataRef.current, mediaEpisode];

    //IF RESTRICTIONS ARE PRESENT FILTER DATA AS PER RESTRICTIONS
    if (dataItem.Template && dataItem.Template?.Restrictions && dataItem.Template?.Restrictions?.length > 0) {
      tempData = utility.getDataFilteredByRestrictions(tempData, dataItem.Template.Restrictions);
    }

    setIngetionData(tempData);
    setFilterIngestionData(tempData);

  }

  const onSearch = (e) => {
    e.preventDefault();
    setFilterSearch(e.target.value);
    const keyword = e.target.value?.toLowerCase();

    if (keyword == undefined || keyword == "") {
      setFilterIngestionData(ingetionData);
      return;
    }

    let filterSearchData = ingestionDataRef.current.filter((item) => {
      for (let key in item) {
        if (typeof item[key] === 'string' && item[key].toLowerCase().includes(keyword)) {
          return item;
        }
      }
    });
    setFilterIngestionData(filterSearchData);
  }

  const downloadExportReport = () => {
    partnerIngestionRef.current.onDownloadExportReport()
  }

  const onChange = (e) => {
    if (e.target.name == "Status") {
      if (e.target.value.SID == 0) {
        setFilterIngestionData(ingetionData);
      } else {
        let filterSearchData = ingestionDataRef.current.filter((item) => item.success == e.target.value.SID);
        setFilterIngestionData(filterSearchData);
      }
    }
    if (e.target.name == "IsAllChannel") {
      setSelectAllChannels(!selectAllChannels);
      setChannels(!selectAllChannels ? channelsRef.current : []);
    }

    setDataItem({ ...dataItem, [e.target.name]: e.target.value });
    setFilterSearch("");
  }

  return (
    <>
      <div className="row m-1 mb-3" style={{ boxShadow: "0px 5px 10px 1px lightgrey", backgroundColor: "#EEEEEE", borderRadius: "10px", padding: '10px 0px 5px 0px' }}>

        <div className="col-2">
          <label><strong>{lang.template_label}</strong></label>
          <DropDownList
            style={{
              height: "32px",
              backgroundColor: "white"
            }}
            data={partnerIngetionTemplates}
            name="Template"
            textField="TemplateName"
            value={dataItem.Template}
            onChange={handleChange}
          />
          <label className="text-muted"><small>{`Type - ${selectedIngestionTemplateFileType}`}</small></label>
        </div>

        {dataItem.Template && dataItem.Template?.ModuleType && (dataItem.Template?.ModuleType?.IsContentRequired || dataItem.Template?.ModuleType?.SID == INGESTION_MODULETYPES.Segmentation) &&
          <div className="col-2 form-group" style={{ padding: '0px 0px 0px 5px' }}>
            <label><strong>{lang.channel_label}</strong></label>
            <span className="float-right">{lang.select_all_label}
              <input
                type="checkbox"
                name="IsAllChannel"
                className="ml-1"
                value={selectAllChannels}
                checked={selectAllChannels}
                onChange={onChange}
              />
            </span>
            <MyMultiSelect
              style={{
                maxHeight: "45px",
                backgroundColor: "white",
                overflow: "auto"
              }}
              dataItemKey="_id"
              data={channelsRef.current}
              name="Channel"
              textField="FullChannelName"
              value={channels}
              onChange={(e) => {
                e.target.value.length == channelsRef.current.length ? setSelectAllChannels(true) : setSelectAllChannels(false);
                setChannels(e.target.value)
              }}
            />
          </div>}

        {dataItem.Template && dataItem.Template?.ModuleType && dataItem.Template?.ModuleType?.IsContentRequired && dataItem.Template?.isOtt &&
          <div className="col-2" style={{ padding: '0px 0px 0px 10px' }}>
            <label><strong>{lang.platform_label}</strong></label>
            <MyMultiSelect
              style={{ backgroundColor: "white", overflow: "auto" }}
              dataItemKey="_id"
              data={platformRef.current}
              name="Platforms"
              textField="Description"
              value={platforms}
              onChange={(e) => { setPlatforms(e.target.value) }}
            />
          </div>}

        {dataItem.Template && dataItem.Template?.IsSports && dataItem.Template?.ModuleType?.SID != INGESTION_MODULETYPES.Season &&
          <div className="col-2" style={{ padding: '0px 0px 0px 5px' }}>
            <label><strong>{lang.match_type_label}</strong></label>
            <DropDownList
              style={{ backgroundColor: "white" }}
              dataItemKey="_id"
              data={matchTypeRef.current}
              name="MatchType"
              textField="Description"
              value={matchType}
              onChange={(e) => { setMatchType(e.target.value) }}
            />
          </div>}

        {!isAPITemplateSelected &&
          <div className="col-3">
            <div style={{ display: 'flex', marginTop: "25px" }}>
              <input type="text" className="form-control form-control-sm" name="filename" value={fileDataItem.file ?? ""} disabled={true} />
              <button
                type="button"
                className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-secondary"
                style={{ padding: '0px', height: "32px", width: "42px", margin: '0px 0px 0px 3px' }}
                onClick={handleBrowseClick}
              >
                <i className="fa-solid fa-ellipsis-h" />
              </button>

              <input
                ref={fileRef}
                id="fileupload"
                name="file"
                type="file"
                hidden
                onChange={handleFileChange}
                accept={
                  selectedIngestionTemplateFileType === "Excel"
                    ? ".xlsx,.xls"
                    : selectedIngestionTemplateFileType === "CSV"
                      ? ".csv"
                      : ""
                }
              />
            </div>
          </div>}

        <div className={isAPITemplateSelected ? "col-2" : "col-1"} style={{ marginTop: "25px", padding: isAPITemplateSelected ? "0px 15px" : "0px" }}>
          {isAPITemplateSelected && <button title={lang.load_button_tooltip} type="button" onClick={(e) => onLoadDataViaAPI(e)} className="btn-square btn-primary" style={{ marginLeft: "-10px" }}>
            {lang.load_button_text}
          </button>}
          <button title={lang.ingest_button_tooltip} type="button" onClick={onIngest} className="btn-square btn-success" style={{ marginLeft: `${!isAPITemplateSelected ? "-10px" : "5px"}` }}>
            {lang.ingest_button_text}
          </button>
        </div>

        {dataItem.Template && dataItem.Template?.ModuleType && dataItem.Template?.ModuleType?.SID == INGESTION_MODULETYPES.Schedule &&
          dataItem.Template?.isSelectManualDate && <div className="col-1 form-group" style={{ padding: '0px' }}>
            <label htmlFor=""> {lang.schedule_date_label} </label>
            <input
              name={"ScheduleDate"}
              className="form-control form-control-sm"
              type={"date"}
              value={scheduleDate}
              onChange={(e) => setScheduleDate(e.target.value)}
            />
          </div>}

        {dataItem.Template && dataItem.Template?.ModuleType &&
          (dataItem.Template?.ModuleType?.SID == INGESTION_MODULETYPES.Planning || dataItem.Template?.ModuleType?.SID == INGESTION_MODULETYPES.Schedule) &&
          dataItem.Template?.ModuleType?.IsChannelRequired && <div className="col-2" style={{ display: 'flex', marginTop: "30px", padding: '0px 0px 0px 35px' }}>
            <div className=" form-group">
              <input
                name={"ReplacePlanning"}
                type={"Checkbox"}
                value={replacePlanning}
                onChange={(e) => setReplacePlanning(e.target.checked)}
                checked={replacePlanning}
                style={{
                  marginLeft: "0px",
                  marginRight: "5px",
                }}
              /></div>
            <label htmlFor="TabView">
              {lang.replace_existing_planning_label}
            </label>
          </div>}

        {dataItem.Template && dataItem.Template?.ModuleType && dataItem.Template?.ModuleType?.SID == INGESTION_MODULETYPES.Schedule &&
          dataItem.Template?.ModuleType?.IsChannelRequired && <div className="col-1" style={{ display: 'flex', marginTop: "30px", padding: '0px' }}>
            <div className=" form-group">
              <input
                name={"Fill Gaps"}
                type={"Checkbox"}
                value={fillGap}
                onChange={(e) => setFillGap(e.target.checked)}
                checked={fillGap}
                style={{
                  marginLeft: "0px",
                  marginRight: "5px",
                }}
              /></div>
            <label htmlFor="TabView">
              {lang.fill_gaps_label}
            </label>
          </div>}

        {dataItem.Template && dataItem.Template?.ModuleType && dataItem.Template?.ModuleType?.IsCreateMedia && <div className="col-2" style={{ display: 'flex', marginTop: "30px", padding: '0px' }}>
          <div className=" form-group">
            <input
              name={"CreateMedia"}
              type={"Checkbox"}
              value={createMedia}
              onChange={(e) => setCreateMedia(e.target.checked)}
              checked={createMedia}
              style={{
                marginLeft: "0px",
                marginRight: "5px",
              }}
            /></div>
          <label htmlFor="TabView">
            {'Create Media'}
          </label>
        </div>}

        {dataItem.Template && dataItem.Template?.ModuleType && dataItem.Template?.ModuleType?.IsCreateParent && <div className="col-2" style={{ display: 'flex', marginTop: "30px", padding: '0px' }}>
          <div className=" form-group">
            <input
              name={"CreateParent"}
              type={"Checkbox"}
              value={createParent}
              onChange={(e) => setCreateParent(e.target.checked)}
              checked={createParent}
              style={{
                marginLeft: "0px",
                marginRight: "5px",
              }}
            /></div>
          <label htmlFor="TabView">
            {'Create Parent Series'}
          </label>
        </div>}

        {dataItem.Template && dataItem.Template?.ModuleType && dataItem.Template?.ModuleType?.SID == INGESTION_MODULETYPES.Segmentation && <div className="col-2" style={{ display: 'flex', marginTop: "30px", padding: '0px' }}>
          <div className=" form-group">
            <input
              name={"Update Segment"}
              type={"Checkbox"}
              value={updateSegmentation}
              onChange={(e) => setUpdateSegmentation(e.target.checked)}
              checked={updateSegmentation}
              style={{
                marginLeft: "0px",
                marginRight: "5px",
              }}
            /></div>
          <label htmlFor="TabView">
            {'Update Segmentation'}
          </label>
        </div>}

        {dataItem.Template && dataItem.Template?.ModuleType &&
          (dataItem.Template?.ModuleType?.SID == INGESTION_MODULETYPES.Program ||
            dataItem.Template?.ModuleType?.SID == INGESTION_MODULETYPES.Movie ||
            dataItem.Template?.ModuleType?.SID == INGESTION_MODULETYPES.Episode ||
            dataItem.Template?.ModuleType?.SID == INGESTION_MODULETYPES.Season ||
            dataItem.Template?.ModuleType?.SID == INGESTION_MODULETYPES.Series ||
            dataItem.Template?.ModuleType?.SID == INGESTION_MODULETYPES.Interstitial ||
            dataItem.Template?.ModuleType?.SID == INGESTION_MODULETYPES.Commercial ||
            dataItem.Template?.ModuleType?.SID == INGESTION_MODULETYPES.Filler
          ) && <div className="col-2" style={{ display: 'flex', marginTop: "30px", padding: '0px' }}>
            <div className=" form-group">
              <input
                name={"Update Media"}
                type={"Checkbox"}
                value={updateMedia}
                onChange={(e) => setUpdateMedia(e.target.checked)}
                checked={updateMedia}
                style={{
                  marginLeft: "0px",
                  marginRight: "5px",
                }}
              /></div>
            <label htmlFor="TabView">
              {'Update Data'}
            </label>
          </div>}

      </div>

      <div style={{ padding: '15px', boxShadow: "5px 0px 10px 1px lightgrey", backgroundColor: "#EEEEEE", borderRadius: "10px" }}>
        <div className="d-flex">
          {/* Status */}
          <div className="mr-auto">
            <label className="mb-0 me-2">{lang.status_label} :</label>
            <DropDownList
              style={{ backgroundColor: "white", width: "130px" }}
              data={status}
              name="Status"
              dataItemKey="SID"
              textField="Description"
              value={dataItem.Status}
              onChange={onChange}
            />
          </div>

          {/* Right Side */}
          <div className="mr-2">
            <RoundButton
              icon={"download"}
              btnColor={"info"}
              style={{ color: "white" }}
              title={lang.export_button_tooltip}
              onClick={downloadExportReport}
            />
          </div>
          <div className="input-group mb-2" style={{ width: "300px" }} >
            <input
              type="text"
              className="form-control shadow-inset-2 pt-0 pb-0"
              id="searchInput"
              placeholder={lang.search_button_text}
              value={filterSearch}
              onChange={onSearch}
            />
            <span className="input-group-text">
              <i className="fa fa-search" />
            </span>
          </div>
        </div>
        <PartnerIntegrationDetailCollection isLoading={isLoading} ref={partnerIngestionRef} data={filterIngestionData} setDataList={setSelectedIngestionData} mode={"multiple"} template={dataItem.Template} setClearSelected={setClearSelected} clearSelected={clearSelected} />
      </div>

      {showProgressBar.progressBarPopup && <div id='myProgressBar'>
        <div className='myProgressBarBox'>
          <ProgressBar
            label={(props) => {
              return <strong>{props.value}%</strong>;
            }}
            labelPlacement='center'
            progressStyle={{ backgroundColor: "green" }}
            value={progressData.progress}
            style={{ width: "360px" }}
          />
          <div className='message'>
            <p>{progressData.message}</p>
          </div>
          {showProgressBar.okButton && <button onClick={() => { setShowProgressBar({ ...showProgressBar, progressBarPopup: false }); }} style={{ width: "50px" }} className='k-button k-button-md k-rounded-md k-button-solid k-button-solid-base bg-success text-white' >Ok</button>}
        </div>
      </div>}
      {showHeaderRowSheetIndexPopup && <HeaderRowAndSheetPopup onConfirm={handleOnHeaderRowSheetIndexConfirm} onClose={() => { setShowHeaderRowSheetIndexPopup(false) }} sheets={selectedExcelSheets} setHeaderRowSheetIndex={setHeaderRowSheetIndex} />}
    </>)
};

export default PartnerIngetion;